<div class="camera-history">
	<header class="camera-history__head">
		<div>
			<h3 class="camera-history__title">{{ data.name }}</h3>
			<p class="camera-history__subtitle">Level over the last {{ rangeDays }} days</p>
		</div>
		<div class="camera-history__tools">
			<div class="camera-history__switch" role="group" aria-label="Time range">
				<button
					*ngFor="let option of ranges"
					type="button"
					class="camera-history__switch-option"
					[class.camera-history__switch-option--active]="option.value === range"
					[attr.aria-pressed]="option.value === range"
					(click)="onRangeChange(option.value)">
					{{ option.label }}
				</button>
			</div>
			<button mat-icon-button type="button" mat-dialog-close aria-label="Close">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</header>

	<div class="camera-history__switch camera-history__switch--views" role="group" aria-label="Show" *ngIf="data.showBrewVision">
		<button
			*ngFor="let option of views"
			type="button"
			class="camera-history__switch-option"
			[class.camera-history__switch-option--active]="option.value === view"
			[attr.aria-pressed]="option.value === view"
			(click)="onViewChange(option.value)">
			{{ option.label }}
		</button>
	</div>

	<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

	<p class="camera-history__message" role="alert" *ngIf="loadError">{{ loadError }}</p>

	<div class="camera-history__chart" *ngIf="chart && hasData">
		<apx-chart
			[series]="chart.series"
			[chart]="chart.chart"
			[colors]="chart.colors"
			[stroke]="chart.stroke"
			[dataLabels]="chart.dataLabels"
			[markers]="chart.markers"
			[legend]="chart.legend"
			[grid]="chart.grid"
			[xaxis]="chart.xaxis"
			[yaxis]="chart.yaxis"
			[tooltip]="chart.tooltip"
			[annotations]="chart.annotations"
		></apx-chart>
	</div>

	<p class="camera-history__message" *ngIf="chart && !hasData && !isLoading">
		No levels for this canister in this period.
	</p>

	<p class="camera-history__legend" *ngIf="chart && hasData">
		<span class="camera-history__legend-item" *ngIf="view !== 'machine' && data.showBrewVision">
			<span class="camera-history__swatch camera-history__swatch--brewvision"></span>
			BrewVision reading
		</span>
		<span class="camera-history__legend-item" *ngIf="view !== 'brewvision'">
			<span class="camera-history__swatch camera-history__swatch--machine"></span>Machine level
		</span>
		<span class="camera-history__legend-item"><span class="camera-history__swatch camera-history__swatch--restock"></span>Restock logged on the machine</span>
		<span class="camera-history__legend-item" *ngIf="data.showBrewVision">
			<span class="camera-history__swatch camera-history__swatch--unlogged"></span>Refill BrewVision saw, not logged
		</span>
	</p>

	<p class="camera-history__note" *ngIf="chart && hasData && view !== 'brewvision'">
		Machine level is how full the machine believed this canister was. Gaps mark restocks it didn't record.
	</p>
</div>
